<template>
  <main v-if="$store.state.user.PageNotFound === 1">
      <Auth></Auth>
  </main>
  <main v-else-if="$store.state.isLogin === 1">
      <Admin></Admin>
  </main>
  <main v-else-if="$store.state.isLogin === 2">
      <Auth></Auth>
  </main>
  <main class="auth-wrapper" v-else>
      <Auth></Auth>
  </main>
  <vue-progress-bar></vue-progress-bar>
</template>
<script>
  import Auth from './pages/layout/auth.vue'
  import Admin from './pages/layout/Admin.vue'

  export default {
      name: 'App',
      components: {
          Auth,
          Admin
      },
      data() {
          return {
              isAdmin: 1
          }
      },
  }
</script>
